[
    {
        "name": "first_run",
        "label": "First Run",
        "description": "Indicates if the application is running the first time",
        "type": "Boolean",
        "value": "true",
        "enabled": true
    },
    {
        "name": "authentication",
        "label": "Authentication",
        "description": "Enable application authentication",
        "type": "Boolean",
        "value": "false",
        "enabled": true
    }
]
